import { Box, Stack } from '@mui/material';
import { PoolLink, useIsMobile } from '@synergy/components-next';
import { ReactElement } from 'react';

import { SupplierListItemBoxProps } from './supplier-list-item-box-props';
import { VerticalDivider } from '../../../../components/vertical-divider/vertical-divider';

export const SupplierListItemBoxLinks = (props: SupplierListItemBoxProps): ReactElement => {
    const isMobile = useIsMobile();

    return isMobile ? (
        <SupplierListItemBoxLinksMobile item={props.item} />
    ) : (
        <SupplierListItemBoxLinksDesktop item={props.item} />
    );
};

const SupplierListItemBoxLinksDesktop = (props: SupplierListItemBoxProps): ReactElement => {
    const preventEventPropagation = (event: React.MouseEvent): void => {
        event.stopPropagation();
    };

    return (
        <Stack direction="row" gap={1} divider={<VerticalDivider />}>
            {props.item.phone && (
                <PoolLink href={`tel:${props.item.phone}`} onClick={preventEventPropagation}>
                    {props.item.phone}
                </PoolLink>
            )}
            {props.item.email && (
                <PoolLink href={`mailto:${props.item.email}`} onClick={preventEventPropagation}>
                    {props.item.email}
                </PoolLink>
            )}
        </Stack>
    );
};

const SupplierListItemBoxLinksMobile = (props: SupplierListItemBoxProps): ReactElement => {
    const preventEventPropagation = (event: React.MouseEvent): void => {
        event.stopPropagation();
    };
    return (
        <>
            {props.item.phone && (
                <Box>
                    <PoolLink href={`tel:${props.item.phone}`} onClick={preventEventPropagation}>
                        {props.item.phone}
                    </PoolLink>
                </Box>
            )}
            {props.item.email && (
                <Box>
                    <PoolLink href={`mailto:${props.item.email}`} onClick={preventEventPropagation}>
                        {props.item.email}
                    </PoolLink>
                </Box>
            )}
        </>
    );
};
